import { Languages } from '@/common/constants/languages';
import translations from '@/common/locales';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next)?.init({
  resources: {
    en: {
      translation: translations.en,
    }
  },
  lng: Languages.EN,
  fallbackLng: Languages.EN,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
